import Calendar from "@/utils/calendar";

const singleProductTypes = ["多品", "单品"];
const statusList = { 0: '初始化', 1: '待处理', 2: '处理中', 3: '已完成' }
export const columns = [
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    rowKey: 'key',
    scopedSlots: {
      customRender: "productImg",
    },
  },
  {
    title: "批次号(源)",
    dataIndex: "pkgCode",
    key: "pkgCode",
    rowKey: 'key'
  },
  {
    title: "批次号(新)",
    dataIndex: "newPkgCode",
    key: "newPkgCode",
    rowKey: 'key',
    customRender: (text, record, index) => {
      return text || "-"
    },
  },
  {
    title: "状态",
    key: "state",
    dataIndex: "state",
    rowKey: 'key',
    customRender: (text, record, index) => {
      return statusList[text]
    },
  },
  {
    title: "商品名",
    key: "productName",
    dataIndex: "productName",
    ellipsis: true,
  },
  {
    title: "商品规格",
    dataIndex: "productProp",
    key: "productProp",
    rowKey: 'key',
  },
  {
    title: '数量',
    key: 'defectiveAmount',
    dataIndex: 'defectiveAmount',
    rowKey: 'key',
  },
  {
    title: "所在库区",
    dataIndex: "regionName",
    key: "regionName",
    rowKey: 'key',
  },
  {
    title: "库位",
    key: "gridCode",
    dataIndex: "gridCode",
    rowKey: 'key',
  },
  {
    title: "创建时间",
    key: "createTime",
    dataIndex: "createTime",
    rowKey: 'key',
    customRender: (text, record, index) => {
      return text || '-'
    },
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    rowKey: 'key',
    width: 100,
    fixed:'right',
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const detailColums = [
  {
    title: "操作内容",
    dataIndex: "context",
    key: "context",
    rowKey: 'context'
  },
  {
    title: "操作人",
    dataIndex: "editorName",
    key: "editorName",
    rowKey: 'editorName'
  },
  {
    title: "操作时间",
    dataIndex: "updateTime",
    key: "updateTime",
    rowKey: 'updateTime'
  },
]
